<template>

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="400.000000pt" height="400.000000pt" viewBox="0 0 400.000000 400.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.16, written by Peter Selinger 2001-2019
</metadata>
<g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
stroke="none">
<path d="M340 3228 l0 -345 193 -6 c105 -4 221 -13 257 -21 272 -59 506 -249
621 -501 98 -216 98 -494 0 -710 -115 -252 -349 -442 -621 -501 -36 -8 -152
-17 -257 -21 l-193 -6 0 -345 0 -344 248 5 c201 4 265 9 344 26 616 135 1081
599 1220 1218 20 85 23 127 23 323 0 249 -12 326 -76 513 -153 447 -522 817
-967 971 -189 66 -268 78 -544 83 l-248 5 0 -344z"/>
<path d="M1670 3511 c220 -157 397 -346 520 -556 l44 -73 260 -4 c239 -3 265
-5 306 -24 60 -28 108 -77 138 -143 44 -96 17 -219 -63 -289 -71 -63 -84 -67
-274 -70 l-173 -4 7 -51 c33 -254 33 -340 0 -594 l-7 -51 173 -4 c155 -3 178
-5 214 -25 85 -46 135 -122 143 -219 4 -51 0 -71 -20 -115 -30 -65 -78 -114
-138 -143 -42 -19 -65 -21 -306 -24 l-260 -4 -44 -73 c-123 -210 -300 -399
-520 -556 l-83 -60 639 3 c622 3 641 4 717 25 343 97 595 352 688 699 32 116
32 334 1 459 -26 103 -102 268 -155 338 l-37 47 37 48 c53 69 129 234 155 337
31 125 31 343 -1 459 -93 347 -345 602 -688 699 -76 21 -95 22 -717 25 l-639
3 83 -60z"/>
</g>
</svg>
   
</template>

<script>
  export default {
		name: 'D3Icon',
    props: {
      icon: {
        type: String,
        default: '$cancel'
      }
    }
  }
</script>
<style scoped>
svg{
	fill:currentColor;
}
</style>>

